export default {
  code: {
    appStoreDown: "苹果版本下载",
    googlePlayDown: "谷歌版本下载",
    androidDown: "安卓版本下载",
    huaweiDown: "华为版本下载",
    stratumMessage: "点击右上角选择浏览器打开",
    iKnow: "知道了",
    update: "更新",
    cancel: "取消",
    noData: "暂无数据",
    installationNotice: "安装提示",
    huaweiDownTips: {
      after: "🔐 如果安装受阻？关闭纯净模式：",
      before: "设置 → 系统和更新 → 纯净模式 → 退出"
    },
    xiaomiDownTips: {
      after: "🔐 如果安装受阻？点击单次授权：",
      before: "右上角“更多”图标 → 授权单次安装"
    }
  }

};
